import { createAction } from 'redux-act';

/** Полезная нагрузка формы купонов (данные с бэка или для создания). */
export type CouponFormPayload = Record<string, unknown> | null;

export const setCouponModalVisible = createAction<boolean>('SET_COUPON_MODAL_VISIBLE');
export const setCouponForm = createAction<CouponFormPayload>('SET_COUPON_FORM');
export const closeCouponForm = createAction('CLOSE_COUPON_FORM');
